<template>
  <div class="wrapper">
    <div class="btn-toolbar">
      <div class="form-inline">
        <input type="text" placeholder="Feld- / Gruppenname" v-model="newname" class="form-control"/>
      </div>
      <div class="btn-group ml-2">
        <button @click="addField" class="btn btn-secondary"><font-awesome-icon icon="dice-one"/>&nbsp;Feld</button>
        <button @click="addGroup" class="btn btn-secondary"><font-awesome-icon icon="layer-group"/>&nbsp;Gruppe</button>
      </div>
    </div>
    <table class="table table-stripes mt-2">
      <tr v-for="(val,key) in data" :key="key">
        <td style="min-width:20%;">
          <div class="input-group">
            <div class="input-group-prepend">
              <button @click="deleteField(key)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
            </div>
            <div class="input-group-append">
              <span v-bind:class="{ 'alert-info': !val._ctrl}" class="input-group-text">{{ key }}</span>
            </div>
          </div>
        </td>
        <td v-if="!val._ctrl" class="col-md">
          <ServiceFieldsEditor :data="val"/>
        </td>
        <td v-else>
          <div class="form-inline">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">RegEx</span>
              </div>
              <input v-model="val._ctrl.regex" type="text" class="form-control"/>
            </div>
          </div>
          <div class="form-check">
            <input v-model="val._ctrl.req" type="checkbox" class="form-check-input">
            <label class="form-check-label">Required</label>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ServiceFieldsEditor',
  props: ["data"],
  data() {
    return {
      newname: ''
    }
  },
  methods: {
    checkName: function() {
      if (this.newname == '') {
        this.$bvToast.toast('Bitte erst einen Namen eingeben.',{title:'Vorlagenfeld',variant:'warning'});
        return false;
      }
      return true;
    },
    addField: function() {
      console.log('add field');
      if (!this.checkName()) return;
      this.data[this.newname] = {"_ctrl":{}};
      this.$forceUpdate();
    },
    deleteField: function(key) {
      delete this.data[key];
      this.$forceUpdate();
    },
    addGroup: function(){
      if (!this.checkName()) return;
      console.log('add group');
      this.data[this.newname] = {};
      this.$forceUpdate();
    }
  }
}
</script>
